import { connect } from "react-redux";
import { list_orders, get_order_detail } from "../../redux/actions/orders";
import { useParams, Navigate } from "react-router";
import { useEffect } from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";
import SideNav from "../../components/dashboard/Sidebar";

const styles = StyleSheet.create({
  page: { padding: 30 },
  section: { marginBottom: 20 },
  heading: { fontSize: 18, marginBottom: 10, fontWeight: "bold" },
  text: { fontSize: 12, marginBottom: 5 },
  table: { display: "table", width: "100%", borderWidth: 1, marginBottom: 20 },
  tableRow: { flexDirection: "row" },
  tableCol: { flex: 1, borderWidth: 1, padding: 5 },
  tableCell: { fontSize: 10 },
});

const PDFInvoice = ({ order }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.heading}>Factura</Text>
        <Text style={styles.text}>
          ID de Transacción: {order.transaction_id}
        </Text>
        <Text style={styles.text}>
          Fecha de Emisión:{" "}
          {new Date(order.date_issued).toLocaleDateString("es-ES", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.heading}>Detalles del Cliente</Text>
        <Text style={styles.text}>Nombre: {order.full_name}</Text>
        <Text style={styles.text}>Teléfono: {order.telephone_number}</Text>
        <Text style={styles.text}>
          Dirección: {order.address_line_1}{" "}
          {order.address_line_2 && `, ${order.address_line_2}`}
        </Text>
        <Text style={styles.text}>
          Ciudad: {order.city}, {order.state_province_region},{" "}
          {order.country_region}
        </Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.heading}>Productos</Text>
        <View style={styles.table}>
          <View style={[styles.tableRow, { backgroundColor: "#f2f2f2" }]}>
            <Text style={[styles.tableCol, styles.tableCell]}>Producto</Text>
            <Text style={[styles.tableCol, styles.tableCell]}>Cantidad</Text>
            <Text style={[styles.tableCol, styles.tableCell]}>
              Precio Unitario
            </Text>
            <Text style={[styles.tableCol, styles.tableCell]}>Total</Text>
          </View>
          {order.order_items.map((producto) => (
            <View key={producto.id} style={styles.tableRow}>
              <Text style={[styles.tableCol, styles.tableCell]}>
                {producto.name}
              </Text>
              <Text style={[styles.tableCol, styles.tableCell]}>
                {producto.count}
              </Text>
              <Text style={[styles.tableCol, styles.tableCell]}>
                ${producto.price.toFixed(2)}
              </Text>
              <Text style={[styles.tableCol, styles.tableCell]}>
                ${(producto.count * producto.price).toFixed(2)}
              </Text>
            </View>
          ))}
        </View>
      </View>
      <View style={styles.section}>
        <Text style={styles.text}>
          Costo de Envío: ${order.shipping_price.toFixed(2)}
        </Text>
        <Text style={styles.text}>
          Total Factura: ${order.amount.toFixed(2)}
        </Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.text}>
          Gracias por su compra. Si tiene alguna consulta, por favor
          contáctenos.
        </Text>
      </View>
    </Page>
  </Document>
);

const DashboardPaymentDetail = ({
  order,
  isAuthenticated,
  get_order_detail,
  user,
}) => {
  const params = useParams();
  const transaction_id = params.transaction_id;

  useEffect(() => {
    get_order_detail(transaction_id);
  }, [transaction_id, get_order_detail]);

  if (!isAuthenticated) return <Navigate to="/" />;

  // Manejar la espera de datos del pedido
  if (!order) {
    return (
      <SideNav user={user}>
        <div className="p-6">
          <h1 className="text-2xl font-bold mb-4">Cargando detalles...</h1>
        </div>
      </SideNav>
    );
  }

  return (
    <SideNav user={user}>
      <div className="p-6">
        <h1 className="text-2xl font-bold mb-4">Factura</h1>
        <div className="bg-white p-6 rounded shadow-md">
          <div className="mb-6">
            <h2 className="text-lg font-semibold">
              Detalles de la Transacción
            </h2>
            <p>ID de Transacción: {order.transaction_id}</p>
            <p>
              Fecha de Emisión:{" "}
              {new Date(order.date_issued).toLocaleDateString("es-ES", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </p>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-semibold">Detalles del Cliente</h2>
            <p>Nombre: {order.full_name}</p>
            <p>Teléfono: {order.telephone_number}</p>
            <p>
              Dirección: {order.address_line_1}{" "}
              {order.address_line_2 && `, ${order.address_line_2}`}
            </p>
            <p>
              Ciudad: {order.city}, {order.state_province_region},{" "}
              {order.country_region}
            </p>
          </div>
          <div className="mb-6">
            <h2 className="text-lg font-semibold">Productos</h2>
            <table className="table-auto w-full border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-200 px-4 py-2 text-left">
                    Producto
                  </th>
                  <th className="border border-gray-200 px-4 py-2 text-right">
                    Cantidad
                  </th>
                  <th className="border border-gray-200 px-4 py-2 text-right">
                    Precio Unitario
                  </th>
                  <th className="border border-gray-200 px-4 py-2 text-right">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {order.order_items.map((producto) => (
                  <tr key={producto.id}>
                    <td className="border border-gray-200 px-4 py-2">
                      {producto.name}
                    </td>
                    <td className="border border-gray-200 px-4 py-2 text-right">
                      {producto.count}
                    </td>
                    <td className="border border-gray-200 px-4 py-2 text-right">
                      ${producto.price.toFixed(2)}
                    </td>
                    <td className="border border-gray-200 px-4 py-2 text-right">
                      ${(producto.count * producto.price).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-6 text-right">
            <p>Costo de Envío: ${order.shipping_price.toFixed(2)}</p>
            <p className="text-lg font-bold">
              Total: ${order.amount.toFixed(2)}
            </p>
          </div>
        </div>
        <div className="mt-6">
          <PDFDownloadLink
            document={<PDFInvoice order={order} />}
            fileName={`Factura_${order.transaction_id}.pdf`}
            className="bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
          >
            {({ loading }) => (loading ? "Generando PDF..." : "Descargar PDF")}
          </PDFDownloadLink>
        </div>
      </div>
    </SideNav>
  );
};

const mapStateToProps = (state) => ({
  order: state.Orders.order,
  isAuthenticated: state.Auth.isAuthenticated,
  user: state.Auth.user,
});

export default connect(mapStateToProps, { list_orders, get_order_detail })(
  DashboardPaymentDetail,
);
